import { getDateString } from '../../../utils/timeUtils';
import { getUserFullName } from '../../../utils/userUtils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportLastViewed = ({
  report
}) => {
  const currentReport = report;
  const lastViewedUser = currentReport.get('lastViewUser');
  const lastViewedTimestamp = currentReport.get('lastViewedAt');
  if (!lastViewedTimestamp) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.lastViewed",
      options: {
        viewedDate: '--'
      }
    });
  }
  const lastViewedUserName = getUserFullName(lastViewedUser);
  if (!lastViewedUserName) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reports.reportCard.details.lastViewed",
      options: {
        viewedDate: getDateString(lastViewedTimestamp)
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "reports.reportCard.details.lastViewedBy",
    options: {
      viewedDate: getDateString(lastViewedTimestamp),
      userFullName: lastViewedUserName
    }
  });
};